import React from 'react';
import './Spinner.css';

const Spinner: React.FC = () => {
  return (
    <div className="loading-overlay">
      <div className="spin"></div>
    </div>
  );
};

export default Spinner;
